import { get } from "../../service/api";

const GetSubMerchantTransaction = async (
  merchantId,
  subMerchant,
  queryString
) => {
  try {
    const response = await get(
      `/merchant/${merchantId}/vatMerchant/${subMerchant}/transaction?1=1${queryString}`
    );
    return response;
  } catch (error) {
    console.error("Error GetSubMerchantTransaction:", error);
    throw error;
  }
};

export default GetSubMerchantTransaction;
